module.exports = __webpack_public_path__ + "img/xmsb8.312f0bc6.png";